import { getAuthHeader } from "../utils/api";

export interface DownloadUrlResponse {
  downloadUrl: string;
  filename: string;
  expiresIn: number; // seconds
}

/**
 * Generate a short-lived presigned URL for downloading a file
 * @param fileKey - The S3 key of the file to download (URL encoded)
 * @param filename - Optional desired filename for the download
 * @returns Promise with download URL and metadata
 */
export const generateDownloadUrl = async (fileKey: string, filename?: string): Promise<DownloadUrlResponse> => {
  const headers = await getAuthHeader();
  
  // Encode the file key for URL path
  const encodedFileKey = encodeURIComponent(fileKey);
  
  // Add optional filename as query parameter
  const queryParams = filename ? `?filename=${encodeURIComponent(filename)}` : '';
  
  const response = await fetch(
    `${import.meta.env.VITE_API_URL}/utility/download/${encodedFileKey}${queryParams}`,
    {
      method: 'GET',
      headers,
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Failed to generate download URL: ${response.status}`);
  }

  return response.json();
}; 